import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { UserProfileService } from "src/app/parametrage/core/service/user-profile.service";

@Component({
  selector: "app-trouver-employee-modal",
  templateUrl: "./trouver-employee-modal.component.html",
  styleUrls: ["./trouver-employee-modal.component.scss"],
})
export class TrouverEmployeeModalComponent implements OnInit {
  form2: FormGroup;
  pressButton: Boolean = false;

  userProfiles: UserProfile[];
  employees: Employee[];

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _employeeService: EmployeeService,
    private _userProfileService: UserProfileService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      roleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getUserProfiles();
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userProfiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleId = this.form2.value.roleAffected;
    this._employeeService.getEmployeeByProfile(roleId).subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
      this.activeModal.close(this.form2.value.userAffected);
  }
}
